import React from 'react';
import PropTypes from 'prop-types';
import CodeMirror from '@uiw/react-codemirror';
import { color } from '@uiw/codemirror-extensions-color';
import { javascript } from '@codemirror/lang-javascript';
import { json } from '@codemirror/lang-json';
import { css } from '@codemirror/lang-css';
import { liquid } from '@codemirror/lang-liquid';
import { html } from '@codemirror/lang-html';
import { xcodeLight } from '@uiw/codemirror-theme-xcode';

import './code.scss';

export default class StorefrontCodeMirror extends React.PureComponent {
  static propTypes = {
    file: PropTypes.object.isRequired,
  };

  state = {
    extensions: null,
  };

  componentDidMount() {
    this.setState({
      extensions: this.getExtensions(this.props),
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.file !== this.props.file) {
      this.setState({
        extensions: this.getExtensions(this.props),
      });
    }
  }

  getExtensions(props = this.props) {
    const { file } = props;

    const extensions = [color];

    if (file.file_path.endsWith('.js')) {
      extensions.push(javascript({ jsx: true }));
    }
    if (file.file_path.endsWith('.json')) {
      extensions.push(json());
    }
    if (file.file_path.endsWith('.css')) {
      extensions.push(css());
    }
    if (file.file_path.endsWith('.liquid')) {
      extensions.push(liquid());
    }
    if (file.file_path.endsWith('.html') || file.file_path.endsWith('.svg')) {
      extensions.push(html());
    }

    return extensions;
  }

  render() {
    const { file, onChange } = this.props;
    const { extensions } = this.state;

    if (!extensions) {
      return null;
    }

    return (
      <CodeMirror
        id="code-mirror"
        width="100%"
        height="100%"
        value={file.file_data || ''}
        onChange={onChange}
        extensions={extensions}
        basicSetup={{
          lineNumbers: true,
          foldGutter: true,
        }}
        theme={xcodeLight}
      />
    );
  }
}
